import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "swiper/css";
import "swiper/css/pagination";
import { Helmet } from "react-helmet";
import ServiceInclude from "../../component/ServiceInclude";


const SalesCloud = () => {

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <>
            <Helmet prioritizeSeoTags={true}>
                <meta http-equiv="content-type" content="text/html; charset=utf-8" />
                <meta name="format-detection" content="telephone=no" />
                <title>Top Salesforce Sales Cloud Consultant</title>
                <meta name="viewport" content="width=device-width, initial-scale=1" />

                <meta name="description"
                    content="Codezix is leading Salesforce Sales Cloud consulting and partner company specialised in providing Sales cloud CRM specific solution to customer in USA , UK and more"
                />
                <meta
                    name="keywords"
                    content=" "
                />
            </Helmet>

            <div className="service-banner top bottom">
                <div className="container">
                    <div className='explore-heading'>
                        <h2>Salesforce Sales Cloud</h2>
                    </div>
                    <div className="service-img mt-4">
                        <img src={require('../../assets/images/salesforce/sales-cloud/sales-cloud.webp')} alt="" />
                    </div>
                </div>
            </div>

            <div className="container">
                <div className="row">
                    <div className="col-lg-3">
                        <ServiceInclude />
                    </div>

                    <div className="col-lg-9">

                        <div className="salesforce-service">
                            <p className="prose-lg wow fadeUp">
                                The goal of Salesforce Sales Cloud is to streamline and automate the sales process, benefiting both sales managers and representatives. Key features of Sales Cloud help establish a well-organized sales process, track adherence to it, provide in-depth customer insights, and facilitate efficient communication with customers across multiple channels. When properly administered, configured, or customized, Sales Cloud can significantly enhance your sales performance and deliver greater value:
                            </p>
                        </div>

                        <div className="sasesforce-benifit">
                            <div className='explore-service text-left'>
                                <h2>Salesforce Implementation Benefits</h2>
                            </div>
                            <div className="row mt-5">
                                <div className="col-md-4">
                                    <div className="benifit-number">
                                        <h3>38% </h3>
                                        <p className="wow fadeUp prose-lg">increase in sales productivity</p>
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <div className="benifit-number">
                                        <h3>28% </h3>
                                        <p className="wow fadeUp prose-lg">increase in sales revenue</p>
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <div className="benifit-number">
                                        <h3>26% </h3>
                                        <p className="wow fadeUp prose-lg">increase in the opportunity win rate</p>
                                    </div>
                                </div>
                                <p className="wow fadeUp prose-lg">Source: Salesforce Customer Success Metrics Survey</p>
                            </div>
                        </div>

                        <div className="salesforce-service">
                            <div className='explore-service text-left'>
                                <h2>How Salesforce Sales Cloud Helps to Sell</h2>
                                <p className="wow fadeUp prose-lg text-left">Salesforce Sales Cloud provides comprehensive digital workplaces for everyone in sales, including sales managers, sales reps, customer success reps, and presales specialists. Discover how Sales Cloud can revolutionize your sales team's daily operations.</p>
                            </div>
                            <div className="row">
                                <div className="col-lg-4 col-md-6 mt-3">
                                    <div className="cloud-help">
                                        <div className="icons-help">
                                            <img src={require('../../assets/images/salesforce/sales-cloud/target.webp')} alt="" />
                                            <span>FIXED</span>
                                        </div>
                                        <p className="prose-md mt-2">Policies are supported by validation rules and automated workflows.</p>
                                    </div>
                                </div>
                                <div className="col-lg-4 col-md-6 mt-3">
                                    <div className="cloud-help">
                                        <div className="icons-help">
                                            <img src={require('../../assets/images/salesforce/sales-cloud/target.webp')} alt="" />
                                            <span>ISSUE</span>
                                        </div>
                                        <p className="prose-md mt-2">Salesforce automatically notifies sales managers when their attention is required.</p>
                                    </div>
                                </div>
                                <div className="col-lg-4 col-md-6 mt-3">
                                    <div className="cloud-help">
                                        <div className="icons-help">
                                            <img src={require('../../assets/images/salesforce/sales-cloud/target.webp')} alt="" />
                                            <span>ISSUE</span>
                                        </div>
                                        <p className="prose-md mt-2">Salesforce Sales Cloud keeps sales quotas, price books, commission calculation organized.</p>
                                    </div>
                                </div>
                                <div className="col-lg-4 col-md-6 mt-3">
                                    <div className="cloud-help">
                                        <div className="icons-help">
                                            <img src={require('../../assets/images/salesforce/sales-cloud/target.webp')} alt="" />
                                            <span>ISSUE</span>
                                        </div>
                                        <p className="prose-md mt-2">Processes are supported by Salesforce workflows configured with a point-and-click tool, Process Builder.</p>
                                    </div>
                                </div>
                                <div className="col-lg-4 col-md-6 mt-3">
                                    <div className="cloud-help">
                                        <div className="icons-help">
                                            <img src={require('../../assets/images/salesforce/sales-cloud/target.webp')} alt="" />
                                            <span>ISSUE</span>
                                        </div>
                                        <p className="prose-md mt-2">+38% sales productivity. It may sound too good, but it’s confirmed by a Salesforce’s customer success survey.</p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="contact-shadow top_padding">
                            <div className="row mb-4">
                                <div className="valuation-box">
                                    <div className="col-md-9">
                                        <h3>Would you like to see how Sales Cloud can benefit your business?</h3>
                                        <p className="prose-lg wow fadeUp">With 10+ years of experience in delivering CRM solutions and services, Codezix helps businesses boost their sales with Salesforce Sales Cloud.</p>
                                    </div>
                                    <div className="col-md-3">
                                        <div className="button_exp mt-5">
                                            <Link to="/contact"><button>Contact us</button> </Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="selesforce-services mt-5 mb-4">
                            <div className='explore-heading text-left'>
                                <h2>Key Features of Salesforce Sales Cloud</h2>
                                <p className="wow fadeUp prose-lg text-left">Explore the key features of Sales Cloud that help both sales managers and sales reps perform their tasks with greater efficiency:</p>
                            </div>
                            <div className="inner-salesforce-service mt-4">
                                <div className="row">
                                    <div className="col-md-2">
                                        <div className="innner-service-logo">
                                            <img src={require('../../assets/images/salesforce/sales-cloud/lead-1.webp')} alt="" />
                                        </div>
                                    </div>
                                    <div className="col-md-10">
                                        <div className="innner-service-text">
                                            <p className="wow fadeUp prose-lg"><strong>Sales Path </strong> Enables sales managers to define and easily manage the sales process. It outlines the expected actions for sales reps at each stage, helping managers ensure their reps follow the desired workflow.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="inner-salesforce-service mt-4">
                                <div className="row">
                                    <div className="col-md-2">
                                        <div className="innner-service-logo">
                                            <img src={require('../../assets/images/salesforce/sales-cloud/lead-2.webp')} alt="" />
                                        </div>
                                    </div>
                                    <div className="col-md-10">
                                        <div className="innner-service-text">
                                            <p className="wow fadeUp prose-lg"><strong>Lead conversion process </strong> Sales Cloud can be customized to fit your business needs, taking into account specific B2B and B2C requirements. You can tailor the lead conversion process to either convert leads into an opportunity, account, and contact, or just into an opportunity and account. Additionally, you can implement automated workflows and validation criteria to ensure a smooth and consistent lead conversion process.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="inner-salesforce-service mt-4">
                                <div className="row">
                                    <div className="col-md-2">
                                        <div className="innner-service-logo">
                                            <img src={require('../../assets/images/salesforce/sales-cloud/lead-3.webp')} alt="" />
                                        </div>
                                    </div>
                                    <div className="col-md-10">
                                        <div className="innner-service-text">
                                            <p className="wow fadeUp prose-lg"><strong>Reports and dashboards </strong> Enable sales managers to track key sales metrics alongside the performance of their sales reps. By identifying strengths and weaknesses, as well as factors affecting productivity, sales managers can enhance their reps' performance. Advanced sales forecasting supports smarter decision-making and helps shape effective sales strategies.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="inner-salesforce-service mt-4">
                                <div className="row">
                                    <div className="col-md-2">
                                        <div className="innner-service-logo">
                                            <img src={require('../../assets/images/salesforce/sales-cloud/lead-4.webp')} alt="" />
                                        </div>
                                    </div>
                                    <div className="col-md-10">
                                        <div className="innner-service-text">
                                            <p className="wow fadeUp prose-lg"><strong>Products and Price Books</strong> Enable the creation of pricing rules for products and services, supporting multiple currencies. Sales managers can approve significant discounts for specific customer groups based on factors like industry or geography. This feature also allows for price adjustments while preserving the original prices for previously sent proposals, ensuring control without the need for manual effort during price changes.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="inner-salesforce-service mt-4">
                                <div className="row">
                                    <div className="col-md-2">
                                        <div className="innner-service-logo">
                                            <img src={require('../../assets/images/salesforce/sales-cloud/lead-5.webp')} alt="" />
                                        </div>
                                    </div>
                                    <div className="col-md-10">
                                        <div className="innner-service-text">
                                            <p className="wow fadeUp prose-lg"><strong>Process Builder </strong> Facilitates the creation of automated workflows, giving sales managers more opportunities to oversee and enhance their reps' performance.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="inner-salesforce-service mt-4">
                                <div className="row">
                                    <div className="col-md-2">
                                        <div className="innner-service-logo">
                                            <img src={require('../../assets/images/salesforce/sales-cloud/lead-6.webp')} alt="" />
                                        </div>
                                    </div>
                                    <div className="col-md-10">
                                        <div className="innner-service-text">
                                            <p className="wow fadeUp prose-lg"><strong>Sales Cloud Einstein </strong> Equips sales managers with AI-powered analytics, enabling more accurate sales predictions through advanced analysis of historical pipeline data, business trends, and past opportunity engagements.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="selesforce-services mt-5 mb-4">
                            <div className='explore-heading text-left'>
                                <h2>For Sales Reps</h2>
                            </div>
                            <div className="inner-salesforce-service mt-4">
                                <div className="row">
                                    <div className="col-md-2">
                                        <div className="innner-service-logo">
                                            <img src={require('../../assets/images/salesforce/sales-cloud/lead-7.webp')} alt="" />
                                        </div>
                                    </div>
                                    <div className="col-md-10">
                                        <div className="innner-service-text">
                                            <p className="wow fadeUp prose-lg"><strong>Tasks and Events Management.</strong> Reps can easily manage their activities (emails, calls, meetings, and tasks) using an intelligent activity timeline in the Lightning Experience UI. This feature provides reps with a comprehensive view of all activities related to a specific opportunity or account, all within a single record, eliminating the need to search through different related lists.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="inner-salesforce-service mt-4">
                                <div className="row">
                                    <div className="col-md-2">
                                        <div className="innner-service-logo">
                                            <img src={require('../../assets/images/salesforce/sales-cloud/lead-8.webp')} alt="" />
                                        </div>
                                    </div>
                                    <div className="col-md-10">
                                        <div className="innner-service-text">
                                            <p className="wow fadeUp prose-lg"><strong>Social Accounts and Contacts</strong> Provide sales reps with information on contacts or accounts from various social networks (LinkedIn, Facebook, Twitter, YouTube). This enables sales reps to better understand and address their customers' needs more effectively.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="inner-salesforce-service mt-4">
                                <div className="row">
                                    <div className="col-md-2">
                                        <div className="innner-service-logo">
                                            <img src={require('../../assets/images/salesforce/sales-cloud/lead-9.webp')} alt="" />
                                        </div>
                                    </div>
                                    <div className="col-md-10">
                                        <div className="innner-service-text">
                                            <p className="wow fadeUp prose-lg"><strong>Lightning Voice </strong> Facilitates communication with prospects and customers by enabling one-click calling and automated call logging. Additionally, it allows sales reps' phone numbers to be localized to their respective sales territories, resulting in higher response rates.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="inner-salesforce-service mt-4">
                                <div className="row">
                                    <div className="col-md-2">
                                        <div className="innner-service-logo">
                                            <img src={require('../../assets/images/salesforce/sales-cloud/lead-5.webp')} alt="" />
                                        </div>
                                    </div>
                                    <div className="col-md-10">
                                        <div className="innner-service-text">
                                            <p className="wow fadeUp prose-lg"><strong>Process Builder </strong> Helps automate numerous manual tasks, such as following up on leads or nurturing opportunities, through email notifications and automated field updates. This allows sales reps to complete their routine tasks more quickly and efficiently.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="inner-salesforce-service mt-4">
                                <div className="row">
                                    <div className="col-md-2">
                                        <div className="innner-service-logo">
                                            <img src={require('../../assets/images/salesforce/sales-cloud/lead-6.webp')} alt="" />
                                        </div>
                                    </div>
                                    <div className="col-md-10">
                                        <div className="innner-service-text">
                                            <p className="wow fadeUp prose-lg"><strong>Sales Cloud Einstein </strong> Provides valuable support for sales reps' decision-making by notifying them about key moments in their deals, identifying leads most likely to convert, and highlighting opportunities that require their attention. Additionally, recommendations for the next steps in customer communication help turn client interactions into a comprehensive win.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="salesforce-services mt-5">
                            <div className="salesforce-product ">
                                <div className='explore-heading text-left'>
                                    <h2>Why 150,000 Businesses Chose Salesforce</h2>
                                    <p className="wow fadeUp prose-lg text-left">Though Salesforce is a powerful platform for sales and marketing automation, some companies need to extend its capabilities. In this regard, the Codezix team can deliver Salesforce integration to:</p>
                                </div>
                                <h3 className="para_heading">Tailored to Your Industry, Your Business</h3>
                                <p className="wow fadeUp prose-lg lext-left">Developing CRM software demands significant time and financial investment. Salesforce.com, Inc. has spent 20+ years evolving its platform, now serving 150,000 customers across various industries. The vast experience built into Salesforce Sales Cloud is difficult for niche players to replicate.</p>
                                <p className="wow fadeUp prose-lg text-left">You might be wondering how Salesforce, as a universal CRM, can cater to your unique business needs. The following features enable Sales Cloud to be tailored to fit any business that uses it:</p>
                                <div className="why-listing mt-4">
                                    <ul>
                                        <li className="wow fadeUp prose-lg"> Functionality that covers all sales processes and incorporates best sales practices.</li>
                                        <li className="wow fadeUp prose-lg"> We facilitate knowledge transfer and mining, including documentation on configurations, customizations, and more.</li>
                                        <li className="wow fadeUp prose-lg"> We manage service planning and oversee the transfer of responsibilities.</li>
                                    </ul>
                                </div>

                                <h3 className="para_heading">High ROI</h3>
                                <p className="wow fadeUp prose-lg ml-5">We deliver the agreed-upon scope of Salesforce support and provide monthly performance analysis and reporting. Throughout our partnership, we adhere to consistent security standards to ensure the safety of your business information. Our robust approach to information security management is validated by ISO 27001 certification.</p>
                                <h3 className="para_heading">Convenient for Salespeople</h3>
                                <div className="why-listing mt-4">
                                    <ul>
                                        <li className="wow fadeUp prose-lg"> Functionality that covers all sales processes and incorporates best sales practices.</li>
                                        <li className="wow fadeUp prose-lg"> We facilitate knowledge transfer and mining, including documentation on configurations, customizations, and more.</li>
                                        <li className="wow fadeUp prose-lg"> We manage service planning and oversee the transfer of responsibilities.</li>
                                    </ul>
                                </div>

                                <h3 className="para_heading">Collaborating with Other Applications</h3>
                                <p className="wow fadeUp prose-lg ml-5"> Salesforce customers integrate Sales Cloud with ERP, supply chain, HR, ecommerce, and other software from thousands of vendors via API (application programming interface).
                                    With over 2,000 apps available on AppExchange, integration with other applications is made easy.
                                    If you require more specific and in-depth integration, Codezix will be happy to assist and develop custom code tailored to your needs.</p>
                            </div>

                        </div>

                        <div className="Choose-plan-section bottom_padding">
                            <div className="row top_padding">
                                <div className="col-md-6 mt-3">
                                    <div className="plan-item">
                                        <h3>Essentials</h3>
                                        <p className="prose-lg">Good for small companies with a sales team of up to 10 people</p>
                                        <div className="why-listing mt-4">
                                            <ul>
                                                <li className="wow fadeUp prose-lg"> Lead management</li>
                                                <li className="wow fadeUp prose-lg"> Account, contact and opportunity management</li>
                                                <li className="wow fadeUp prose-lg"> Sales tasks</li>
                                                <li className="wow fadeUp prose-lg"> Sales reporting</li>
                                            </ul>
                                        </div>
                                        <p className="prose-lg text-center mt-5"><span>$25</span>user/month</p>
                                        <div className="demo-button">
                                            <button>Request demo</button>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6 mt-3">
                                    <div className="plan-item">
                                        <h3>Professional</h3>
                                        <p className="prose-lg">Good for small companies with a sales team of up to 10 people</p>
                                        <div className="why-listing mt-4">
                                            <ul>
                                                <li className="wow fadeUp prose-lg"> Product and Price Books</li>
                                                <li className="wow fadeUp prose-lg"> Quote and order management</li>
                                                <li className="wow fadeUp prose-lg"> Contract management</li>
                                                <li className="wow fadeUp prose-lg"> Process Builder (up to 5 processes)</li>
                                                <li className="wow fadeUp prose-lg">Integration with external systems (at an additional cost)</li>
                                            </ul>
                                        </div>
                                        <p className="prose-lg text-center"><span>$75</span>user/month</p>
                                        <div className="demo-button">
                                            <button>Request demo</button>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-md-6 mt-3">
                                    <div className="plan-item">
                                        <h3>Enterprise</h3>
                                        <p className="prose-lg">Ideal for enterprises</p>
                                        <div className="why-listing mt-4">
                                            <ul>
                                                <li className="wow fadeUp prose-lg"> All features of Professional</li>
                                                <li className="wow fadeUp prose-lg"> Enterprise territory management</li>
                                                <li className="wow fadeUp prose-lg"> Opportunity teams and split</li>
                                                <li className="wow fadeUp prose-lg"> Advanced sales forecasting and reporting</li>
                                                <li className="wow fadeUp prose-lg">Highly customizable with code</li>
                                                <li className="wow fadeUp prose-lg">Unlimited workflows and approval processes, integrations</li>
                                            </ul>
                                        </div>
                                        <p className="prose-lg text-center mt-5"><span>$150</span>user/month</p>
                                        <div className="demo-button">
                                            <button>discuss Implementation</button>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6 mt-3">
                                    <div className="plan-item">
                                        <h3>Unlimited</h3>
                                        <p className="prose-lg">Suitable for large companies with hundreds of salespeople</p>
                                        <div className="why-listing mt-4">
                                            <ul>
                                                <li className="wow fadeUp prose-lg"> All features of Enterprise</li>
                                                <li className="wow fadeUp prose-lg">Numbers of custom objects, fields and validation rules that cover any imaginable need</li>
                                                <li className="wow fadeUp prose-lg"> Priority access to support, a full training library and a comprehensive knowledge database</li>
                                            </ul>
                                        </div>
                                        <p className="prose-lg text-center mt-5"><span>$300</span>user/month</p>
                                        <div className="demo-button">
                                            <button>discuss Implementation</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="contact-shadow top_padding">
                            <div className="row mb-4">
                                <div className="valuation-box">
                                    <div className="col-md-9">
                                        <h3>Are You in Doubt What Edition Suits You?</h3>
                                        <p className="prose-lg wow fadeUp">Let us analyze your needs in sales automation, suggest an edition with an optimal cost-functionality balance and assist with its implementation.</p>
                                    </div>
                                    <div className="col-md-3">
                                        <div className="button_exp mt-5">
                                            <Link to="/contact"><button>Request Consulting</button> </Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div >
        </>
    )
}

export default SalesCloud;